import { BannerKindType, BANNER_TYPE } from '@/types/banner';

import Icon from '@/components/common/iconedLinks/Icon';
import { CallToActionContainerProps } from '@/components/common/callToAction/CallToActionContainer';

import styles from './Banner.module.scss';
import { URLS } from '@/constants/urls';

type BannerProps = {
  type: BannerKindType;
  content?: string;
  title?: string;
  showLeading?: boolean;
  callToAction?: React.ReactElement<CallToActionContainerProps>;
  minimal?: boolean;
};

const ICON = {
  [BANNER_TYPE.ERROR]: URLS.DELETE_CIRCLE_RED,
  [BANNER_TYPE.INFORMATION]: URLS.INFORMATION_BLUE,
  [BANNER_TYPE.SUCCESS]: URLS.CHECKED_CIRCLE_GREEN,
  [BANNER_TYPE.WARNING]: URLS.WARNING_ORANGE
};

export const Banner = ({ type, title, showLeading = true, callToAction, content = '', minimal = false }: BannerProps) => {
  const containerClassName = [
    styles.container,
    styles[type.toLowerCase()],
    minimal && styles.minimal
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClassName}>
      {showLeading && <Icon src={ICON[type]} alt={`icon ${type}`} width={24} height={24} />}
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        {content}
      </div>
      {callToAction && callToAction}
    </div>
  );
};

export default Banner;
